import { font700Sx } from '../../styles/Global.style';

export const buttonSx = {
  ...font700Sx,
  color: '#121212',
};
